import query from '@/components/query/query-constructor';
import { replaceReportRoute, reportRouteParams } from '@/components/query/report-route-query';
import { useReportParams } from '@/composables/useReportParams';
import { useStore } from '@/store';
import { reportSearchRequestParams } from '@/store/reportColumns/report-search-params';

export type PickUrlTableQueryAccess = {
  getTableQueryForCurrentTab: () => Record<string, unknown>;
  getTableQuerySearch: () => Record<string, unknown>;
  getTableColumnsFiltersForCurrentTabInQueryFormat: () => Record<string, unknown>;
};

export type PickUrlContext = PickUrlTableQueryAccess & {
  $route: { name?: string | symbol | null; params: Record<string, unknown> };
  $router: { replace: (...args: unknown[]) => void };
};

export const pushURL = (ctx: PickUrlContext, cb?: () => void, additionalRepportParams?: Record<string, unknown>) => {
  if (ctx.$route.name !== 'app.report')
    return;
  const groupBy = ctx.$route.params.type;

  const {
    filterHaving,
    filterHavingOptions,
    filterHavingValues,
  } = ctx.getTableColumnsFiltersForCurrentTabInQueryFormat();

  const reportParamsApi = useReportParams();
  const store = useStore();
  const savedColumnsPreset = reportParamsApi.savedColumnsInCurentPreset.value[groupBy as string];
  const { order, columns } = savedColumnsPreset || {};

  const searchParams = reportSearchRequestParams(ctx.getTableQuerySearch());

  const {
    view,
    treeLevels,
    tree,
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset,
    status,
  } = ctx.getTableQueryForCurrentTab() as Record<string, unknown>;

  const reportBoostEnabled = store.reportBoostEnabled;

  const data = query.get({
    ...order,
    columns,
    groupBy,
    treeLevels,
    tree,
    view,
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    filterHaving,
    filterHavingOptions,
    filterHavingValues,
    currency,
    limit,
    status,
    reportBoostEnabled,
    offset: (offset as Record<string, number>)[groupBy as string],
    ...searchParams,
  });

  const drill = additionalRepportParams
    ? query.decode({
        ...query.decode(ctx.$route.params.report),
        ...additionalRepportParams,
      })
    : ctx.$route.params.report;

  if (groupBy !== 'undefined' && data !== ctx.$route.params.data) {
    replaceReportRoute(ctx.$router, {
      name: 'app.report',
      params: {
        type: groupBy,
        data: data,
        report: drill,
        ...reportRouteParams({ manual: true, picker: true }),
      },
    }, cb);
  } else {
    if (cb) {
      cb();
    }
  }
};
